import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface MotivoFicaCancelada {
  id: string;
  codigo: string;
  titulo: string;
}

/** Motivos para a linha que o cliente não quer mais e fica no cancelado (23/10/2026). */
export const CODIGOS_MOTIVO_FICA_CANCELADA = ["CLI_DESISTIU", "DESISTENCIA_PORTABILIDADE"] as const;

export function useMotivosFicaCancelada(enabled: boolean) {
  return useQuery({
    queryKey: ["motivos-fica-cancelada"],
    enabled,
    staleTime: 10 * 60_000,
    queryFn: async (): Promise<MotivoFicaCancelada[]> => {
      const { data, error } = await supabase
        .from("motivos_cancelamento")
        .select("id, codigo, titulo")
        .in("codigo", [...CODIGOS_MOTIVO_FICA_CANCELADA])
        .eq("ativo", true);
      if (error) throw error;
      const ordem = (codigo: string) => CODIGOS_MOTIVO_FICA_CANCELADA.indexOf(codigo as typeof CODIGOS_MOTIVO_FICA_CANCELADA[number]);
      return ((data || []) as MotivoFicaCancelada[]).sort((a, b) => ordem(a.codigo) - ordem(b.codigo));
    },
  });
}
